import React, { Component } from 'react';
import { Button, Modal, ModalBody, Row, Col, Container, ModalHeader, ModalFooter } from 'reactstrap';
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';
import BoasVindas from '../../Componente/Modais/BoasVindas';
import { ModalUploadContext } from '../../Providers/ModalUpload';

import './TermoUso.scss';

const isSimulacao = localStorage.getItem('isSimulacao') === 'true';

class TermoUso extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			step: 'Default',
			activeIndex: 0,
			termoAceito: true,
		};

		this.verificaTermoDeUso();
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.salvarTermoDeUso();
		this.setState({ isOpen: false });
	};

	verificaTermoDeUso = () => {
		var url = `${Config.urls.API_URL_BASE}Acesso/VerificaTermoDeUso`;

		return new Promise(() => {
			HttpUtil.eco_GET(url).then(
				response => {
					this.setState({
						termoAceito: response.data,
					});

					if (this.state.termoAceito == false && !isSimulacao) {
						this.setState({
							isOpen: true,
						});
					}
				},
				() => {
					window.location = '/erro';
				},
			);
		});
	};

	salvarTermoDeUso = () => {
		if (this.state.termoAceito == false) {
			var url = `${Config.urls.API_URL_BASE}Acesso/SalvarTermoDeUso`;

			return new Promise(() => {
				HttpUtil.eco_POST(url).then(
					response => {
						this.setState({
							termoAceito: response.data,
						});

						this.BoasVindas.openModal();
					},
					() => {
						window.location = '/erro';
					},
				);
			});
		}
	};

	renderModal() {
		return (
			<div>
				<BoasVindas ref={modal => (this.BoasVindas = modal)} />
				<ModalUploadContext.Consumer>
					{modalUpload => {
						this.openModalUpload = modalUpload.openModal;
						modalUpload.onClosed = this.handleReload;
					}}
				</ModalUploadContext.Consumer>
				<Modal
					id="modal-termo-uso"
					centered={true}
					size="lg"
					isOpen={this.state.isOpen}
					onClosed={this.handleModalClosed}
					backdrop="static">
					<div className="modal-header">
						<Row className="modal-alinhamento-linha">
							<Col md={3}>
								<h5 className="modal-title">Termo de Uso</h5>
							</Col>
							<Col md={9}>
								<img alt="" src="/img/assinatura-acesso-ilimitado.png" />
							</Col>
						</Row>
					</div>
					<ModalBody>
						<div>
							<p>
								Esta ferramenta contempla a emissão da Guia GNRE com as regras previstas nas disposições
								legais em conformidade com as legislações estaduais, através dos dados informados nas
								Notas Fiscais eletrônicas (modelo 55) e no Conhecimento de Transporte eletrônico (modelo
								57).
							</p>
							<div>
								<p>
									Segundo a{' '}
									<a
										href="http://www.econeteditora.com.br/bdi/bc/b15/conv_icms_093_2015.php#cl4"
										target="_blank">
										cláusula quarta
									</a>{' '}
									do{' '}
									<a
										href="http://www.econeteditora.com.br/bdi/bc/b15/conv_icms_093_2015.php"
										target="_blank">
										Convênio ICMS 93/2015
									</a>
									, o recolhimento do DIFAL para não contribuinte deve ser efetuado por meio da Guia
									Nacional de Recolhimento de Tributos Estaduais (GNRE) ou outro documento de
									arrecadação, de acordo com a legislação da unidade federada de destino, por ocasião
									da saída do bem ou do início da prestação de serviço, em relação a cada operação ou
									prestação. O documento de arrecadação deve mencionar o número do respectivo
									documento fiscal e acompanhar o trânsito do bem ou a prestação do serviço.
								</p>
								<p>
									Segundo a{' '}
									<a
										href="http://www.econeteditora.com.br/bdi/bc/b18/convenio_icms_142_2018.php#cl4"
										target="_blank">
										cláusula décima quarta
									</a>{' '}
									do{' '}
									<a
										href="http://www.econeteditora.com.br/bdi/bc/b18/convenio_icms_142_2018.php"
										target="_blank">
										Convênio ICMS 142/2018
									</a>
									, o recolhimento do ICMS-ST, deve ser efetuado por meio da Guia Nacional de
									Recolhimento de Tributos Estaduais (GNRE) ou outro documento de arrecadação, de
									acordo com a legislação da unidade federada de destino.
								</p>
								<p>
									O{' '}
									<a
										href="http://www.econeteditora.com.br/bdi/bc/ant/1989/cv_sinief_006_89.php"
										target="_blank">
										Convênio SINIEF 06/89
									</a>{' '}
									em seu artigo 88, §1º, inciso II , lista os códigos de receita da Guia Nacional de
									Recolhimento de Tributos Estaduais On-Line (GNRE On-Line), para fins de recolhimento
									do ICMS devido nas operações interestaduais.
								</p>
							</div>
							<br />
							<p>A ferramenta não faz emissão de guia para o Estado de São Paulo.</p>
							<br />
							<p>
								A ferramenta EcoGNRE está habilitada para a geração da guia para as seguintes receitas:
							</p>
							<table className="table table-striped table-condensed table-hover table-bordered">
								<thead>
									<tr>
										<th>Código</th>
										<th>Descrição</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>10010-2</td>
										<td>ICMS Consumidor Final não contribuinte outra UF por Operação</td>
									</tr>
									<tr>
										<td>10003-0</td>
										<td>ICMS Transporte</td>
									</tr>
									<tr>
										<td>10009-9</td>
										<td>ICMS Substituição Tributária por Operação</td>
									</tr>
									<tr>
										<td>10012-9</td>
										<td>ICMS Fundo Estadual de Combate à Pobreza por Operação</td>
									</tr>
									<tr>
										<td>10002-1</td>
										<td>ICMS Energia Elétrica</td>
									</tr>
								</tbody>
							</table>

							<p>
								<i className="fa fa-exclamation-circle" aria-hidden="true" /> Para os Estados do Rio de
								Janeiro e Espírito Santo, a ferramenta fará a conversão dos códigos, de acordo com o
								disponibilizado por cada Estado.
							</p>

							<div>
								<p>
									<b>
										Não nos responsabilizamos pelos dados gerados na guia, com relação ao cálculo e
										arredondamentos dos valores apresentados, pois estes dependem exclusivamente dos
										dados contidos no XML e das regras de cada UF através de seus webservices.
										Preventivamente sugerimos que seja verificada também a legislação de cada
										estado.
									</b>
								</p>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Container>
							<Row className="justify-content-center">
								<Button color="info" onClick={() => this.closeModal()}>
									{this.state.termoAceito ? 'Fechar' : 'Eu li e concordo com o termo de uso'}
								</Button>
							</Row>
						</Container>
					</ModalFooter>
				</Modal>
			</div>
		);
	}

	render = () => this.renderModal();
}

export default TermoUso;
